var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[(_vm.validateRoutes)?_c('navbar-landing'):_c('navbar'),_c('div',{staticClass:"app-wrapper pt-3"},[_c('child')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }